import * as actions from '../actions/tobas';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';
import flattenConcurrently from "xstream/extra/flattenConcurrently";

export function requestGetTobaById(sources) {
    const query$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_TOBA_BY_ID);

    const request$ = query$
        .map(action => ({
            url: BASE_URL + 'api/toba/Toba/' + action.payload  ,
            category: 'requestGetTobaById',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));


    let httpResponse$ = sources.HTTP
        .select('requestGetTobaById')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveTobaById(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function receiveErrorGetTobaById(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestGetTobaById')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToReceiveTobaById(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestDeleteToba(sources) {
    const query$ = sources.ACTION
        .filter(action => action.type === ActionTypes.DELETE_TOBA);

    const request$ = query$
        .map(action => ({
            url: BASE_URL + 'api/toba/Toba/' + action.payload  ,
            category: 'requestDeleteToba',
            method: 'DELETE',
            type: 'application/json',
            withCredentials: true
        }));


    let httpResponse$ = sources.HTTP
        .select('requestDeleteToba')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .compose(flattenConcurrently)
        .filter(response => response.status === 200)
        .map(response => actions.receiveDeleteTobaResponse(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function receiveErrorDeletingToba(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestDeleteToba')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .compose(flattenConcurrently)
        .filter(response => response.status !== 200)
        .map(response => actions.failedToDeleteToba(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestGetTobas(sources) {
    const query$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_TOBAS);

    const request$ = query$
        .map(action => ({
            url: BASE_URL + 'api/toba/toba?limit=' + action.payload.limit + '&offset=' + action.payload.offset,
            category: 'requestGetTobas',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));


    let httpResponse$ = sources.HTTP
        .select('requestGetTobas')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveAllTobas(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function receiveErrorRequestGetTobas(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestGetTobas')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToGetTobas(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestGetValidTobas(sources) {
    const query$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_VALID_TOBAS);

    const request$ = query$
        .map(action => ({
            url: BASE_URL + 'api/toba/valid?limit=' + action.payload.limit + '&offset=' + action.payload.offset,
            category: 'requestGetValidTobas',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));


    let httpResponse$ = sources.HTTP
        .select('requestGetValidTobas')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveAllValidTobas(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function receiveErrorRequestGetValidTobas(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestGetValidTobas')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToGetValidTobas(response));

    return {
        ACTION: httpResponse$
    };
}